import { http } from '@/utils/http';

const baseApiUrl =
  '/vote/2020project/2020strikeIllegal/controller.php?enews=';

// 要文
const getNewsListByCate = (query: string, params?: any) => {
  return http.get(`${baseApiUrl}${query}`, {
    params,
  });
};

export { getNewsListByCate };
